// Keeps the app's recent console lines in memory (window.__takehouseLog) so they can be read back when the
// browser's console isn't to hand: automated Safari runs, or a participant's machine during support.
const log: string[] = [];
(window as any).__takehouseLog = log;
const t0 = performance.now();
for (const level of ['info', 'warn', 'error'] as const) {
  const original = console[level].bind(console);
  console[level] = (...args: unknown[]) => {
    const text = args.map((a) => (a instanceof Error ? `${a.name}: ${a.message}` : typeof a === 'string' ? a : safeJson(a))).join(' ');
    log.push(`${((performance.now() - t0) / 1000).toFixed(2)}s ${level} ${text}`);
    if (log.length > 300) {
      log.shift();
      dropped++;
    }
    original(...args);
  };
}
addEventListener('error', (e) => {
  // Where it came from matters most: "Script error." alone means a script from another origin (an extension or
  // browser add-on) threw, which is not the app's.
  const where = e.filename ? ` at ${e.filename.replace(location.origin, '')}:${e.lineno}:${e.colno}` : ' (no source: another origin)';
  const stack = e.error?.stack ? ` | ${String(e.error.stack).split('\n').slice(0, 3).join(' | ')}` : '';
  log.push(`${((performance.now() - t0) / 1000).toFixed(2)}s uncaught ${e.message}${where}${stack}`);
});
// The page freezing is what makes recordings drop frames on the Safari path, so note any long freeze.
try {
  new PerformanceObserver((list) => {
    for (const e of list.getEntries()) {
      if (e.duration < 200) continue;
      const where = (e as any).attribution?.[0]?.containerSrc || (e as any).attribution?.[0]?.name || '';
      log.push(`${(e.startTime / 1000).toFixed(2)}s warn page busy for ${Math.round(e.duration)} ms${where ? ` (${where})` : ''}`);
    }
  }).observe({ type: 'longtask', buffered: true });
} catch {}
addEventListener('unhandledrejection', (e) => log.push(`unhandled ${String((e as PromiseRejectionEvent).reason?.message ?? (e as PromiseRejectionEvent).reason)}`));

function safeJson(v: unknown) {
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}

let sent = 0;
let dropped = 0;
/** Sends new log lines to the server every 15 s and when the page is hidden or closed. */
export function startDiagUpload(studioId: string, key: string, who: () => { participantId: string; name: string }) {
  console.info(`[takehouse] browser: ${navigator.userAgent}`);
  const flush = (beacon = false) => {
    // The log is a rolling window; count what scrolled out so lines are never sent twice.
    const total = dropped + log.length;
    if (total <= sent) return;
    const lines = log.slice(Math.max(0, sent - dropped));
    sent = total;
    const body = JSON.stringify({ ...who(), lines });
    const url = `/api/studios/${studioId}/diag?k=${encodeURIComponent(key)}`;
    if (beacon && navigator.sendBeacon?.(url, new Blob([body], { type: 'application/json' }))) return;
    void fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => {});
  };
  setInterval(flush, 15_000);
  addEventListener('pagehide', () => flush(true));
  addEventListener('visibilitychange', () => document.visibilityState === 'hidden' && flush(true));
  return flush;
}
